import { render, staticRenderFns } from "./Target_Type2.vue?vue&type=template&id=2efcac58"
import script from "./Target_Type2.vue?vue&type=script&lang=js"
export * from "./Target_Type2.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports